// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Box,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Image from 'next/image';

/* -----------------Constants--------------- */
import {
  STUDY_CONTENT_ICON,
} from './constants';

/* -----------------Utils--------------- */
import {
  getContentIcon,
} from '../../common/utils';

const styles = () => ({
  iconStyleLarge: {
    '& svg': {
      width: 40,
      height: 40,
    },
  },
  icon: {
    width: STUDY_CONTENT_ICON,
    height: STUDY_CONTENT_ICON,
    fontSize: STUDY_CONTENT_ICON,
  },
  contentIconImage: {
    borderRadius: 4,
  },
});

type Classes = {
  iconStyleLarge: string,
  icon: string,
  contentIconImage: string
}
type Props = {
  classes: Classes,
  type: *,
  radius: number,
  borderWidth: number,
  largeIcon?: boolean,
  contentIconUrl?: ?string
}
// TODO: This component should be same for auth and unauth (refactor)
const ProgressRingUnAuth = (props: Props) => {
  const {
    classes,
    radius,
    type,
    borderWidth,
    largeIcon = true,
    contentIconUrl,
  } = props;
  return (
    <Box
      border={borderWidth}
      width={radius * 2}
      height={radius * 2}
      borderRadius="50%"
      display="flex"
      borderColor="progress.none"
      justifyContent="center"
      alignItems="center"
    >
      {type ? (
        <Box
          display="flex"
          className={largeIcon ? classes.iconStyleLarge : undefined}
        >
          {contentIconUrl
            ? (
              <Image
                width={24}
                height={24}
                loading="eager"
                src={contentIconUrl}
                alt="type"
                objectFit="contain"
                className={classes.contentIconImage}
              />
            )
            : getContentIcon(type, classes.icon)}
        </Box>
      ) : null}
    </Box>
  );
};

export default withStyles(styles)(ProgressRingUnAuth);
